import React from 'react';
import { Link } from 'react-router-dom'; // Assuming you're using react-router-dom for navigation

const Section = ({ link }) => {
  return (
    <div className="container-fluid ml-5 bg-gray-100 pl-5 pb-3 text-gray-700">
      <nav
        className="flex items-center"
        aria-label="Breadcrumb"
      >
        <Link
          to="/"
          className="text-blue-600 hover:text-blue-800 mr-2"
        >
          Home
        </Link>
        <span className="text-gray-400 mx-1">&gt;</span>
        <span className="text-sm font-medium text-gray-700">{link}</span>
      </nav>
    </div>
  );
};

export default Section;
